module.exports = __webpack_public_path__ + "img/ccrc.d1d36109.jpg";